var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.729,
    height: 18,
    viewBox: "0 0 14.729 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_341",
    "data-name": "Union 341",
    d: "M2.456,18A2.459,2.459,0,0,1,0,15.545V2.455A2.459,2.459,0,0,1,2.456,0h6.6a.822.822,0,0,1,.519.237l2.455,2.455L14.49,5.148a.826.826,0,0,1,.238.627v9.77A2.457,2.457,0,0,1,12.274,18ZM1.636,2.455v13.09a.82.82,0,0,0,.819.819h9.819a.819.819,0,0,0,.817-.819v-9H9a.818.818,0,0,1-.819-.819V1.636H2.456A.82.82,0,0,0,1.636,2.455ZM9.817,4.909h2.117L9.817,2.792Zm-5.726,9a.818.818,0,0,1,0-1.636h6.544a.818.818,0,1,1,0,1.636Zm0-3.272A.818.818,0,0,1,4.092,9h6.544a.818.818,0,1,1,0,1.636Zm0-3.274a.818.818,0,0,1,0-1.637H5.728a.818.818,0,1,1,0,1.637Z",
    fill: "#a2a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMetadata);
export default __webpack_public_path__ + "static/media/menu_metadata.5974eda4a6675f41b8dfd4a624920577.svg";
export { ForwardRef as ReactComponent };